export const makePostTileClickable = () => {
    const tiles = document.querySelectorAll(".attrax-post-tile");

    if (!tiles) return;

    tiles.forEach((tile) => {
        tile.addEventListener("click", () => {
            const link = tile.querySelector("a");
            const href = link?.getAttribute("href");

            if (!href) return;

            window.location.href = href;
        });
    });
};
